import { Component, Inject, OnDestroy } from '@angular/core';
import { MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';

import { GalleryService } from 'app/gallery/gallery.service';
import { ImagePlaceholder
       } from 'collage-designer/stage/placeholder/image-placeholder';
import { PlaceholderService
       } from 'collage-designer/stage/placeholder/placeholder.service';
import { GalleryConstants } from 'core/constants';
import { ProductService } from 'core/product/product.service';
import { EventTrackingService } from 'core/tracking/event-tracking.service';
import { Utils } from '../../core/utils';
import { ToolboxComponent } from '../toolbox.component';
import { ToolboxService } from '../toolbox.service';

@Component({
  selector: 'gallery-toolbox',
  templateUrl: './gallery-toolbox.component.html',
  styleUrls: [ '../toolbox.component.scss', ],
})
export class GalleryToolboxComponent extends ToolboxComponent
    implements OnDestroy
{
  public placeholder: ImagePlaceholder;
  public isPlacingImage: boolean = false;

  private placeholderChangedSubscription: Subscription;
  private uploadProgressChangedSubscription: Subscription;

  constructor(
      mir: MatIconRegistry,
      sanitizer: DomSanitizer,
      @Inject(ToolboxService) toolboxService,
      @Inject(GalleryService) private galleryService,
      @Inject(PlaceholderService) private placeholderService,
      @Inject(EventTrackingService) private eventTrackingService,
      @Inject(ProductService) private productService)
  {
    super(mir, sanitizer, toolboxService);

    this.loadIcon('photos');
    this.placeholder = <ImagePlaceholder> this.placeholder;

    this.placeholderChangedSubscription =
        this.toolboxService.placeholderChanged.subscribe((placeholder) => {
          this.placeholder = placeholder;
          this.isPlacingImage = false;
        });

    this.uploadProgressChangedSubscription =
        this.galleryService.uploadProgressChanged.subscribe((inProgress) => {
          if (!inProgress && GalleryConstants.CLOSE_GALLERY_AFTER_UPLOAD) {
            this.closeIfSmallOrMediumDevice();
          }
        });
  }

  public ngOnDestroy(): void
  {
    this.placeholderChangedSubscription.unsubscribe();
    this.uploadProgressChangedSubscription.unsubscribe();
  }

  public btnOKClick(): void
  {
    this.toolboxService.commitChanges();
    this.galleryService.setSelectedImage(undefined);
    this.removeHighlighter(this.placeholderService.getImagePlaceholders(true));
  }

  public async changeImage(imageId): Promise<void>
  {
    if (this.placeholder) {
      await this.placeholder.loadGalleryImage(imageId);
      this.closeIfSmallOrMediumDevice();
    }
    else {
      const placeholders = this.placeholderService.getImagePlaceholders(true);

      if (placeholders.length === 1) {
        const placeholder = placeholders[0];
        await placeholder.loadGalleryImage(imageId);
        this.closeIfSmallOrMediumDevice();
      }
      else if (placeholders.length > 1) {
        this.placeholderService.disableTextPlaceholders();
        this.galleryService.setSelectedImage(imageId);
        this.addHighlighter(placeholders);
      }
    }
  }

  public get showUploadButton(): boolean
  {
    return Utils.isSmallDevice() || Utils.isMediumDevice();
  }

  public get shouldBeVisible(): boolean
  {
    return !((Utils.isSmallDevice() || Utils.isMediumDevice()) &&
             this.isPlacingImage);
  }

  public trackUploadPhotos(): void
  {
    this.eventTrackingService.track({
      category: this.productService.getCurrentProduct().id,
      action: 'init_photo_upload',
      label: 'gallery_upload_button',
    });
  }

  private addHighlighter(placeholders: Array<ImagePlaceholder>): void
  {
    for (let placeholder of placeholders) {
      placeholder.showPlaceholderHighlighter();
    }

    this.isPlacingImage = true;
  }

  private removeHighlighter(placeholders: Array<ImagePlaceholder>): void
  {
    for (let placeholder of placeholders) {
      placeholder.hidePlaceholderHighlighter();
    }

    this.placeholderService.enableTextPlaceholders();

    this.isPlacingImage = false;
  }

  private closeIfSmallOrMediumDevice(): void
  {
    if (Utils.isSmallDevice() || Utils.isMediumDevice()) {
      this.btnOKClick();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/toolboxes/gallery-toolbox/gallery-toolbox.component.ts